export const marginTop8Sx = { marginTop: '8px' };

export const paddingBottom24Sx = { paddingBottom: '24px' };
